import { RouteProps } from 'react-router';
import Sip from './Sip';
import SipPause from './SipPause';
import SipPauseDetails from './SipPauseDetails';
import SipPauseOTP from './SipPauseOTP';
import SipSuccess from './SipStatus';
import { SipPaths } from './types';

const Routes: RouteProps[] = [
    {
        path: SipPaths.Sip,
        component: SipPause,
    },
    {
        path: SipPaths.SipDetails,
        component: SipPauseDetails,
    },
    {
        path: SipPaths.SipOTP,
        component: SipPauseOTP,
    },
    {
        path: SipPaths.SipSuccess,
        component: SipSuccess,
    }
];

export { Routes as SipRoutes };
